function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M26.25 36.286v-.857A3.6 3.6 0 0 0 22.5 32H5.625A5.4 5.4 0 0 0 0 37.143v13.714A5.4 5.4 0 0 0 5.625 56H26.25A3.6 3.6 0 0 0 30 52.571V39.714a3.6 3.6 0 0 0-3.75-3.428zm.938 16.286a.9.9 0 0 1-.938.857H5.625a2.7 2.7 0 0 1-2.812-2.571V37.143a2.7 2.7 0 0 1 2.813-2.571H22.5a.9.9 0 0 1 .937.857v1.714H6.562a.861.861 0 1 0 0 1.714H26.25a.9.9 0 0 1 .938.857zM22.5 44a1.721 1.721 0 1 0 1.875 1.714A1.8 1.8 0 0 0 22.5 44z",
    transform: "translate(0 -32)",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIcon);
export default __webpack_public_path__ + "static/media/wallet-icon.a99feaf6.svg";
export { ForwardRef as ReactComponent };